import { connect } from 'react-redux'
import { compose } from 'redux'
import { withHandlers } from 'recompose'
import { firebaseConnect } from 'react-redux-firebase'
import SelectProject from './SelectProject'

const enhance = compose(
  firebaseConnect((props, store) => [
    { path: `projects/${store.getState().firebase.auth.uid}` }
  ]),
  connect(({ firebase: { data, auth } }) => ({
    projects: data.projects && data.projects[auth.uid]
  })),
  withHandlers({
    selectProjectOnChange: ({ firebase }) => event => {
      const projectId = event.target.value
      firebase.updateProfile({ selectedProject: projectId})
    }
  })
)

export default enhance(SelectProject)



// WEBPACK FOOTER //
// ./src/components/SelectProject/SelectProjectContainer.js